import { ErrorOutline } from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import { StyledCheckbox } from 'v3/shared/components/Checkbox';
import { RookeryBoldFont, RookeryRegularFont } from 'v3/styles/common';
import { theme } from 'v3/styles/global-styles';

export const confirmationDialogPaperPropsStyle = {
  padding: ' 1.5rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  maxWidth: '40.625rem',
  width: '100%',
  minHeight: '100vh',
  position: 'relative',
  borderRadius: '0.5rem',
  margin: 0,
  border: `1px solid ${theme.palette.secondary.dark}`,
  [theme.breakpoints.up('sm')]: {
    margin: '2rem',
    height: '45rem',
    minHeight: '41rem',
  },
};
export const TagSpaceInputAndCpf = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '2rem',
  paddingBottom: '1rem',

  gap: '2rem',
}));

export const StyledIconButton = styled('button')(({ theme }) => ({
  color: theme.palette.common.white,
  display: 'flex',
  justifyContent: 'end',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
}));

export const StyledDialogContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',
  height: '100%',
  [theme.breakpoints.up('sm')]: {
    height: '41rem',
  },
}));

export const StyledButtonContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'end',
    gap: '1rem',
  },
});

export const FormSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const SectionContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const TitleContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  color: theme.palette.common.black,
}));

export const NumberCircle = styled('div')(({ theme }) => ({
  width: '1.5rem',
  height: '1.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.details.light,
  borderRadius: '100%',
}));

export const AlertContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.orange.light,
  margin: '1rem 0',
  padding: '1rem',
  gap: '0.75rem',
}));

export const StyledErrorIcon = styled(ErrorOutline)(({ theme }) => ({
  color: theme.palette.common.black,
}));

export const AcceptanceBox = styled('div')(({ theme }) => ({
  width: '100%',
  border: `0.0625rem solid ${theme.palette.secondary.light}`,
  borderRadius: '0.5rem',
  color: theme.palette.common.white,
  padding: '0.5rem',
}));

export const SpaceBetween = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  gap: '1rem',
  wordBreak: 'break-all',
}));

export const CheckboxContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gap: '0.5rem',
  margin: '0 0 0 -.5rem',
}));

export const TextContainer = styled('div')(({ theme }) => ({
  display: 'block',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
}));

export const SubtitleMediumSpan = styled('span')(({ theme }) => ({
  font: `400 1rem ${RookeryRegularFont}`,
  color: theme.palette.common.white,
}));

export const TitleMediumSpan = styled('span')(({ theme }) => ({
  font: `700 1rem ${RookeryBoldFont}`,
  color: theme.palette.common.white,
}));

export const StyledCheckboxTerms = styled(StyledCheckbox)(({ theme }) => ({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
}));
